const SET_SELECTED_ARTICLES = (state, payload) => {
  state.currentOrigin.latestItems = payload.latestItems
    ? payload.latestItems.results.map((hit) => hit.item)
    : [];
};

export default SET_SELECTED_ARTICLES;
